import React from "react"
import AvailableServices from "../AvailableServices";

function ServiceSection(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const {
    services,
    sectionId,
    title,
    description,
    serviceSectionPartConfigs,
    orderingEnabled,
    onShowModal,
  } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------


  // -------------------------------------

  return (
    <div className="service-section" id={sectionId}>
      <div className="heading">
        <div className="section-title">
          <h3>{title}</h3>
        </div>
        <div className="section-subtitle">
          <p>{description}</p>
        </div>
      </div>

      <AvailableServices services={services}
                         onShowModal={onShowModal}
                         serviceSectionPartConfigs={serviceSectionPartConfigs}
                         orderingEnabled={orderingEnabled}
      />
    </div>
  )
}

export default ServiceSection
